import { bootstrapApplication } from "@angular/platform-browser";
import { installCryptoRandomUuidPolyfill } from "@partikelart/shared-utils";
import * as Sentry from "@sentry/angular";
import { App } from "./app/app";
import { appConfig } from "./app/app.config";
import { environment } from "./app/environments/environment";

// Fallback for insecure contexts (plain-HTTP remote hosts); must run before any UUID use.
installCryptoRandomUuidPolyfill();

// `buildConfig` only exists in some fileReplacements environment variants.
const buildConfig =
	"buildConfig" in environment && typeof environment.buildConfig === "string" ? environment.buildConfig : "dev";
const version = environment.version || "dev";

Sentry.init({
	dsn: "https://1470989a7305877ca563f77e60f4cb42@o376130.ingest.us.sentry.io/4511110652493824",
	environment: environment.production ? "production" : "development",
	release: `portal-frontend@${buildConfig}-${version}`,
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	// Tracing
	tracesSampleRate: 1.0,
	tracePropagationTargets: ["localhost", /^https:\/\/.*\.partikel-art\.de/],
	// Session Replay
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

Sentry.setTag("customer", environment.customer || "default");
Sentry.setTag("deployment_type", environment.deploymentType || "local");

bootstrapApplication(App, appConfig).catch((err) => {
	console.error("[BOOTSTRAP ERROR]", err);
	Sentry.captureException(err);
});
